import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Undo2 } from 'lucide-react';
import { PRViewContent } from './PRViewContent';

export function PurchaseReturnViewDialog({ pr, open, onOpenChange }) {
  if (!pr) return null;
  return React.createElement(Dialog, { open: open, onOpenChange: onOpenChange },
    React.createElement(DialogContent, { className: 'max-w-2xl max-h-[90vh] overflow-y-auto' },
      React.createElement(DialogHeader, null,
        React.createElement(DialogTitle, { className: 'flex items-center gap-2' },
          React.createElement(Undo2, { className: 'w-5 h-5 text-red-600' }),
          'Purchase Return ', pr.prn_number)),
      React.createElement(PRViewContent, { pr: pr })));
}
